import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { UserDataService } from '../services/user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class MenuEnabledPageGuard implements CanActivate {

  constructor(private menuCtrl: MenuController, private userData: UserDataService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.userData.hasLoggedIn().then(hasLoggedIn => {
      this.menuCtrl.enable(hasLoggedIn);
    });
    return true;

  }
    


}
